import React from 'react';
import { useNavigate } from 'react-router-dom';

const QuickActions = ({ listingId, sellerId, listing }) => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'View Seller Profile',
      icon: '🏪',
      onClick: () => navigate(`/admin/sellers/${sellerId}`),
      color: 'hover:bg-blue-900/30 hover:text-blue-400'
    },
    {
      label: 'View Orders',
      icon: '📦',
      onClick: () => navigate(`/admin/orders?listing_id=${listingId}`),
      color: 'hover:bg-[#ff660e]/20 hover:text-[#ff660e]'
    },
    {
      label: 'Copy Listing ID',
      icon: '📋',
      onClick: () => {
        navigator.clipboard.writeText(listingId);
        alert('Listing ID copied to clipboard!');
      },
      color: 'hover:bg-purple-900/30 hover:text-purple-400'
    },
    {
      label: 'Contact Seller',
      icon: '✉️',
      onClick: () => {
        const email = listing?.seller?.email;
        if (email) {
          window.open(`mailto:${email}?subject=Regarding Your Listing: ${listing?.title}`, '_blank');
        } else {
          alert('Seller email not available');
        }
      },
      color: 'hover:bg-green-900/30 hover:text-green-400'
    }
  ];

  return (
    <div className="bg-gray-800 rounded-xl shadow-lg border border-gray-700 p-6 backdrop-blur-sm">
      <h3 className="text-lg font-medium text-white mb-4 flex items-center gap-2">
        <span className="text-[#ff660e]">⚡</span>
        <span>Quick Actions</span>
      </h3>
      <div className="space-y-2">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className={`w-full text-left px-3 py-2 text-sm text-gray-300 rounded-lg transition-all duration-200 flex items-center gap-2 group ${action.color}`}
          >
            <span className="group-hover:scale-110 transition-transform">{action.icon}</span>
            <span className="group-hover:translate-x-1 transition-transform">{action.label}</span>
            <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">→</span>
          </button>
        ))}
      </div>

      {/* Seller Info Box */}
      {listing?.seller && (
        <div className="mt-6 pt-6 border-t border-gray-700">
          <h4 className="font-medium text-white mb-3 flex items-center gap-2">
            <span className="text-[#ff660e]">🏪</span>
            <span>Seller Information</span>
          </h4>
          <div className="bg-gray-750 rounded-lg p-4 border border-gray-600 space-y-3">
            <div className="group">
              <div className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">Store Name</div>
              <div className="font-medium text-white group-hover:text-[#ff660e] transition-colors">
                {listing.seller.store_name}
              </div>
            </div>
            <div className="group">
              <div className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">Seller</div>
              <div className="font-medium text-white group-hover:text-[#ff660e] transition-colors">
                {listing.seller.first_name} {listing.seller.last_name}
              </div>
            </div>
            <div className="group">
              <div className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">Email</div>
              <div className="font-medium text-white group-hover:text-[#ff660e] transition-colors">
                {listing.seller.email}
              </div>
            </div>
            {listing.seller.phone_number && (
              <div className="group">
                <div className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors">Phone</div>
                <div className="font-medium text-white group-hover:text-[#ff660e] transition-colors">
                  {listing.seller.phone_number}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickActions;